import useBenguide from 'hooks/benguide';
import { useAppDispatch } from 'hooks/redux';
import UPClient from 'modules/clients/UPClient/UPClient';
import {
  ADDITIONAL_PERKS_CHANNEL,
  BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
  BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
  BENGUIDE_NOTIFICATIONS,
  RELOAD_ADDITIONAL_PERKS_PLAN_LIST,
  RELOAD_ADDITIONAL_PERKS_SECTION,
} from 'modules/clients/UPClient/UPClientConst';
import {
  fetchAdditionalPerksPlanList,
  reloadAdditionalPerksSection,
} from 'modules/additionalPerks/slices/additionalPerksSlice';
import useUPClient from 'modules/clients/UPClient/useUPClient';

const AdditionalPerksChannel = () => {
  const dispatch = useAppDispatch();
  const benguide = useBenguide();
  const upClient = useUPClient();
  return (
    <UPClient
      channel={ADDITIONAL_PERKS_CHANNEL}
      subscribe={(event: string) => {
        switch (event) {
          case RELOAD_ADDITIONAL_PERKS_PLAN_LIST:
            dispatch(
              fetchAdditionalPerksPlanList(
                benguide.employerId,
                benguide.planYearId,
                benguide.benefitClasses
              )
            );
            break;
          case RELOAD_ADDITIONAL_PERKS_SECTION:
            dispatch(
              reloadAdditionalPerksSection(
                benguide.masterId,
                benguide.latestRevision
              )
            );
            break;
          case BENGUIDE_NOTIFICATION_HIDE_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
              data: {},
            });
            break;
          case BENGUIDE_NOTIFICATION_SHOW_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
              data: {},
            });
            break;
        }
      }}
    />
  );
};

export default AdditionalPerksChannel;
